import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, ServiceResult, get } from "@insite/client-framework/Services/ApiService";
import { BaseModel, ProductModel } from "@insite/client-framework/Types/ApiModels";

export interface RecentlyViewedParams extends ApiParameter {
    productErpNumber: string;
    pageType: string;
}

export interface RecentlyViewedModel {
    uri: any;
    cookieValue: any;
    productId: any;
    pageType: any;
    recentlyViewedProducts: ProductModel[];
    properties: Properties2;
}

export type RecentlyViewedViewType = "Grid";

export interface Pricing {
    isOnSale: boolean;
    requiresRealTimePrice: boolean;
    additionalResults: AdditionalResults;
    unitCost: number;
    unitCostDisplay: any;
    unitListPrice: number;
    unitListPriceDisplay: string;
    extendedUnitListPrice: number;
    extendedUnitListPriceDisplay: string;
    unitRegularPrice: number;
    unitRegularPriceDisplay: string;
    extendedUnitRegularPrice: number;
    extendedUnitRegularPriceDisplay: string;
    unitNetPrice: number;
    unitNetPriceDisplay: string;
    extendedUnitNetPrice: number;
    extendedUnitNetPriceDisplay: string;
    unitOfMeasure: any;
    vatRate: number;
    vatAmount: number;
    vatAmountDisplay: any;
    unitListBreakPrices: any;
    unitRegularBreakPrices: any;
    regularPrice: number;
    regularPriceDisplay: string;
    extendedRegularPrice: number;
    extendedRegularPriceDisplay: string;
    actualPrice: number;
    actualPriceDisplay: string;
    extendedActualPrice: number;
    extendedActualPriceDisplay: string;
    regularBreakPrices: any;
    actualBreakPrices: any;
    unitListPriceWithVat: number;
    unitListPriceWithVatDisplay: any;
    extendedUnitListPriceWithVat: number;
    extendedUnitListPriceWithVatDisplay: any;
    unitRegularPriceWithVat: number;
    unitRegularPriceWithVatDisplay: any;
    extendedUnitRegularPriceWithVat: number;
    extendedUnitRegularPriceWithVatDisplay: any;
    vatMinusExtendedUnitRegularPrice: number;
}

export interface AdditionalResults {
    inventoryMessageCode: string;
    localInventory: string;
    isVisible: string;
    salesIndicator: string;
}

export interface Availability {
    messageType: number;
    message: string;
    requiresRealTimeInventory: boolean;
}

export interface ProductUnitOfMeasure {
    productUnitOfMeasureId: string;
    unitOfMeasure: string;
    unitOfMeasureDisplay: string;
    description: string;
    qtyPerBaseUnitOfMeasure: number;
    roundingRule: string;
    isDefault: boolean;
    availability: Availability2;
}

export interface Availability2 {
    messageType: number;
    message: any;
    requiresRealTimeInventory: boolean;
}

export interface ProductImage {
    id: string;
    sortOrder: number;
    name: string;
    imageType: string;
    smallImagePath: string;
    mediumImagePath: string;
    largeImagePath: string;
    altText: string;
}

export interface Properties {
    bestseller: string;
    branD_ID: string;
    branD_SHORTDESC: string;
    classificatioN_CODE: string;
    countrY_OF_ORIGIN: string;
    featureBullets1to10: string;
    featureBullets1to3: string;
    iskit: string;
    iteM_WEIGHT: string;
    itemstatus: string;
    jsonSpecs: string;
    minimuM_QTY: string;
    mkt_Info: string;
    musT_SHP_LTL: string;
    ndaaCompliant: string;
    vendor_ID: string;
    productcategoryno: string;
    productcategoryid: string;
    adI_ExclusiveBrands: string;
    branD_SEGMENT: string;
    branD_PATH: string;
    productcategory: string;
    productcategoryurl: string;
    abcCode: string;
    defaultVisibility: string;
    showCheckAvailability: string;
    showAuthorizationRequired: string;
    showPricingUnavailable: string;
    onsalenow: string;
    datalayercategoryList: string;
    vendorAuthRequiredList: string;
    vendorAuthRequiredLink: string;
}

export interface ProductSubscription {
    subscriptionAddToInitialOrder: boolean;
    subscriptionAllMonths: boolean;
    subscriptionApril: boolean;
    subscriptionAugust: boolean;
    subscriptionCyclePeriod: string;
    subscriptionDecember: boolean;
    subscriptionFebruary: boolean;
    subscriptionFixedPrice: boolean;
    subscriptionJanuary: boolean;
    subscriptionJuly: boolean;
    subscriptionJune: boolean;
    subscriptionMarch: boolean;
    subscriptionMay: boolean;
    subscriptionNovember: boolean;
    subscriptionOctober: boolean;
    subscriptionPeriodsPerCycle: number;
    subscriptionSeptember: boolean;
    subscriptionShipViaId: any;
    subscriptionTotalCycles: number;
}

export interface Properties2 {
    getPriceForRecently: string;
}

const recentlyViewedUrl = "api/v2/adiglobalproducts/recentlyviewed";

export async function recentlyViewedProduct(parameter: RecentlyViewedParams): Promise<ServiceResult<RecentlyViewedModel>> {
    try {
        const result = await get<RecentlyViewedModel>(`${recentlyViewedUrl}?`, parameter );
        return {
            successful: true,
            result,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}